module.exports = __webpack_public_path__ + "img/btn_bnr_arr_play.b6335893.svg";